import { collection, getDocs } from 'firebase/firestore';
import { db } from 'config/firebase';
import * as types from './types';

export const loadCategories = () => async (dispatch) => {
  try {
    dispatch({ type: types.LOAD_CATEGORIES_REQUEST });

    const snapshot = await getDocs(collection(db, 'categories'));
    const categories = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    dispatch({
      type: types.LOAD_CATEGORIES_SUCCESS,
      payload: categories,
    });
  } catch (error) {
    dispatch({
      type: types.LOAD_CATEGORIES_FAIL,
      payload: error,
    });
  }
};
